import { render, staticRenderFns } from "./param.vue?vue&type=template&id=32cb4a3f&scoped=true"
import script from "./param.vue?vue&type=script&lang=js"
export * from "./param.vue?vue&type=script&lang=js"
import style0 from "./param.vue?vue&type=style&index=0&id=32cb4a3f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cb4a3f",
  null
  
)

export default component.exports